import { SnapshotOut, types as t, Instance } from 'mobx-state-tree';
import { OddModel, StandardEvent, IOdds, createTipIdent, IOdd, parseTipIdent, EBetGames, getLongTipNameRaw, IOddStore, IOdds1x2, IOddsType, isTipList, ITipList, isOdds1x2, createTipKey, OfferItemState, IRenameTipData, GameBusinessType } from 'eTip--common';

export const game1x2 = t.model({
    odd1: t.maybeNull(OddModel),
    oddX: t.maybeNull(OddModel),
    odd2: t.maybeNull(OddModel),
    odd1X: t.maybeNull(OddModel), //TIPOS only
    oddX2: t.maybeNull(OddModel), //TIPOS only
    odd12: t.maybeNull(OddModel)  //TIPOS only
}).actions(self => {

    const copyRatesFrom: (source: Instance<typeof game1x2>) => void = (source: Instance<typeof game1x2>) => {
        if (source.odd1) {
            self.odd1.setRate(source.odd1.rate);
        }
        if (source.oddX) {
            self.oddX.setRate(source.oddX.rate);
        }
        if (source.odd2) {
            self.odd2.setRate(source.odd2.rate);
        }

        if (!__IsMTS__) {
            if (source.odd1X) {
                self.odd1X.setRate(source.odd1X.rate);
            }
            if (source.oddX2) {
                self.oddX2.setRate(source.oddX2.rate);
            }
            if (source.odd12) {
                self.odd12.setRate(source.odd12.rate);
            }
        }
    }

    return {
        copyRatesFrom
    }
});

export const handicap1x2 = t.compose(
    t.model({ detail: t.string }),
    game1x2
);

export const spreadOrHandicap12 = t.model({
    rate1: t.maybeNull(OddModel),
    rate2: t.maybeNull(OddModel),
    detail: t.string
}).actions(self => {

    const copyRatesFrom: (source: Instance<typeof spreadOrHandicap12>) => void = (source: Instance<typeof spreadOrHandicap12>) => {
        if (source.rate1) {
            self.rate1.setRate(source.rate1.rate);
        }
        if (source.rate2) {
            self.rate2.setRate(source.rate2.rate);
        }
    }

    return {
        copyRatesFrom
    }
});

export const tipList = t.model({
    items: t.optional(t.array(OddModel), [])
}).actions(self => {

    const copyRatesFrom: (source: Instance<typeof tipList>) => void = (source: Instance<typeof tipList>) => {
        if (source.items) {
            source.items.forEach(itemS => {
                let dest = self.items.find(itemD => itemD.key === itemS.key);
                if (dest) {
                    dest.setRate(itemS.rate);
                }
            })
        }
    }

    return {
        copyRatesFrom
    }
});

export const belowOver = t.model({
    detail: t.string,
    tips: t.array(OddModel)
}).actions(self => {

    const copyRatesFrom: (source: Instance<typeof belowOver>) => void = (source: Instance<typeof belowOver>) => {
        if (source.tips) {
            source.tips.forEach(itemS => {
                let dest = self.tips.find(itemD => itemD.key === itemS.key);
                if (dest) {
                    dest.setRate(itemS.rate);
                }
            })
        }
    }

    return {
        copyRatesFrom
    }
});

export const gameDetailStore = t.model({
    ID: t.number,
    LineNumber: t.maybeNull(t.number),
    Name: t.maybeNull(t.string),
    Odds: t.maybeNull(t.union(game1x2, handicap1x2, spreadOrHandicap12, belowOver, tipList)),
}).views(self => {
    return {
        getOddForTicket(ident: string): IOdd { //TODOHT
            return findOddForTicket(ident, self.Odds);
        }
    }
});

export type IgameDetailStore = Instance<typeof gameDetailStore>;

/**
 * Create odds for prematch events. Expecting no suspended in game detail.
 *
 */
const createOddModel = (item: StandardEvent.OddsListItem, renameTipData?: IRenameTipData): IOddStore | null => {
    if (!item) {
        return null;
    }
    return OddModel.create(<SnapshotOut<typeof OddModel>>{
        name: getLongTipNameRaw(item.Name, renameTipData),
        popularity: item.PopularityPercentage,
        rate: item.Rate,
        ident: createTipIdent(item),
        key: createTipKey(item),
        isHighlighted: item.TicketOfDayTip && item.TicketOfDayTip,
        isSuspended: item.State === OfferItemState.Suspended
    });
};

/**
 * Create odds for prematch events. Expecting no suspended in game detail.
 *
 */
export const createOdds = (items: StandardEvent.OddsListItem[], type: GameBusinessType, gameDetailName: string, gameId: string, tipsRename?: IRenameTipData): Instance<typeof game1x2> | Instance<typeof handicap1x2> | Instance<typeof spreadOrHandicap12> | Instance<typeof belowOver> | Instance<typeof tipList> => {

    //MTS always 1,2,0/X for 1x2, 12. See also comment "1X2 - ma id tipu 1,2,3; 12 - ma id tipu 4,5"
    /*
    TODOHRY
    if ((gameId.indexOf("1d") === 0 || gameId.indexOf("6d") === 0 || gameId.indexOf("25d") === 0) && items.find(item => item.Name === "1")) { //TODOCHECK
        type = GameBusinessType.Winner_12;
    }
    else if (gameId.indexOf("14d") === 0 && items.find(item => item.Name === "1")) {
        type = GameBusinessType.Winner_1x2;
    }*/

    switch (type) {
        case GameBusinessType.Handicap1x2: {
            let game = {
                detail: gameDetailName
            };
            items.forEach(i => (game['odd' + (__IsMTS__ ? getNormalizedDrawForMts(i.Name) : i.Name)] = createOddModel(i, tipsRename)));
            return handicap1x2.create(game);
        }
        case GameBusinessType.OverBellow:
            return belowOver.create(<SnapshotOut<typeof belowOver>>{
                detail: gameDetailName,
                tips: items.length ? items.map(item => createOddModel(item)) : []
            });
        case GameBusinessType.VMT:
        case GameBusinessType.CorrectScore:
        case GameBusinessType.TipList:
        case GameBusinessType.Winner_12: //UOF only
            return tipList.create(<SnapshotOut<typeof tipList>>{
                items: items.map(o => createOddModel(o, tipsRename))
            });
        case GameBusinessType.SpreadOrHandicap12:
            return spreadOrHandicap12.create(<SnapshotOut<typeof spreadOrHandicap12>>{
                rate1: createOddModel(items[0], tipsRename),
                rate2: createOddModel(items[1], tipsRename),
                detail: gameDetailName
            });

        case GameBusinessType.Winner_1x2:
            let game: IOdds1x2 = { odd1: null, oddX: null, odd2: null, odd1X: null, oddX2: null, odd12: null };
            items.forEach(i => (game['odd' + (__IsMTS__ ? getNormalizedDrawForMts(i.Name) : i.Name)] = createOddModel(i, tipsRename)));
            return game1x2.create(game);

        default: {
            let game: IOdds1x2 = { odd1: null, oddX: null, odd2: null, odd1X: null, oddX2: null, odd12: null };

            //workaround unknown tip names, //workaround 12
            // for 1X,12,X2 for MTS Synottip come items with 10,12,02, so it's different (hasUnknownName is true). For Tipos MTS comes 1X,12,X2 and differency is virtual.
            let hasUnknownName = items.some(i => {
                if (__IsMTSTipos__ && (i.Name === "1X" || i.Name === "12" || i.Name === "X2")) {
                    return true; //means generate as tiplist
                }
                if (game['odd' + (__IsMTS__ ? getNormalizedDrawForMts(i.Name) : i.Name)] === undefined) {
                    return true;
                }
                game['odd' + (__IsMTS__ ? getNormalizedDrawForMts(i.Name) : i.Name)] = createOddModel(i, tipsRename);
                return false;
            });

            if (
                hasUnknownName ||
                !__IsMTS__ && ( //TODOHL correct?
                    gameId === EBetGames.FirstYellowCard ||
                    gameId === EBetGames.FirstRedCard ||
                    gameId === EBetGames.Standard12 ||
                    gameId === EBetGames.FirstPartResultTennis ||
                    gameId === EBetGames.SecondPartResultTennis ||
                    gameId === EBetGames.ThirdPartResultTennis ||
                    gameId === EBetGames.FourthPartResultTennis ||
                    gameId === EBetGames.FifthPartResultTennis ||
                    gameId === EBetGames.FirstKickOff ||
                    gameId === EBetGames.WinnerTeamPenaltyShootout)
            ) {
                return tipList.create(<SnapshotOut<typeof tipList>>{
                    items: items.map(o => createOddModel(o, tipsRename))
                });
            }

            return game1x2.create(game);
        }
    }
};

const getNormalizedDrawForMts = (tipName: string): string => {
    return (!__IsMTSTipos__ && tipName === "0") ? "X" : tipName;
}

export const convertOdds2OddListItem = (eventId: number, gameId: string, detailId: number, item: IOdds): StandardEvent.OddsListItem => {
    return {
        EventID: eventId,
        DetailID: detailId,
        GameID: gameId,
        Name: item.Name,
        PopularityPercentage: item.PopularityPercentage,
        Rate: item.Rate,
        TipID: item.TipID,
        State: item.State
    };
}

export const findOddForTicket = (ident: string, odds: IOddsType): IOdd => {
    if (odds) {
        if (isTipList(odds)) {
            return (<ITipList>odds).items.find(item => item.ident === ident);
        }

        if (__IsMTS__) {
            for (let key in odds) {
                if (odds.hasOwnProperty(key) && odds[key] && odds[key].ident === ident) {
                    return odds[key];
                }
            }
        } else {
            if (isOdds1x2(odds)) {
                let parsed = parseTipIdent(ident);
                return (<IOdds1x2>odds)[parsed.tipID];
            }
        }
    }
    return null;
}